<template>
  <div class="drawer" :class="{ 'is-open': isOpen }">
    <div class="drawer__content" :class="{ 'is-open': isOpen }">
      <button @click="toggleDrawer()" class="fixed z-50 top-6 right-8">
        <div class="flex items-center gap-2 px-2 py-1 bg-black/60 rounded-md opacity-80 transition-all duration-300 md:hover:opacity-100">
          <span class="text-sm text-white">{{ $t('shared.close') }}</span>
        </div>
      </button>
      <div class="drawer__scrollable">
        <AppNavigation />
      </div>
    </div>
    <div class="drawer__backdrop" :class="{ 'is-open': isOpen }" @click="toggleDrawer()"></div>
  </div>
</template>

<script setup>
const route = useRoute()
const app = useAppStore()

// Check if drawer is open based on query param
const isOpen = computed(() => !!route.query?.drawer)

// Toggle drawer with update query
const toggleDrawer = () => {
  useUpdateQuery({ drawer: !route.query?.drawer ? true : undefined })
}
 
// Watch route query to toggle app scroll lock
watch(() => route.query, () => {
  app.lockScroll = !!route.query?.drawer
})
</script>

<style lang="scss" scoped>
.drawer {
  @apply fixed z-50 inset-0 opacity-0 pointer-events-none transition-all duration-300 delay-300;

  &.is-open {
    @apply opacity-100 pointer-events-auto delay-0;
    @apply lg:hidden;
  }

  &__content {
    @apply bg-white;
    @apply w-full max-w-md;
    @apply fixed z-20 top-0 right-0 bottom-0;
    @apply translate-x-full transition-all duration-300;

    &.is-open {
      @apply translate-x-0;
    }
  }

  &__scrollable {
    @apply py-6 px-8;
    @apply flex flex-col justify-start h-full;
    @apply overflow-y-scroll;
    -webkit-overflow-scrolling: touch;
  }

  &__backdrop {
    @apply fixed z-10 inset-0 backdrop-blur-sm bg-black/0 transition-all duration-300;

    &.is-open {
      @apply bg-black/40;
    }
  }
}
</style>